import { createAction, handleActions } from 'redux-actions';
import { Map } from 'immutable';
export const actions = {
    REQUEST: createAction('ACCOUNTS/ORGANIZATION_USER/REQUEST'),
    SUCCESS: createAction('ACCOUNTS/ORGANIZATION_USER/SUCCESS'),
    ERROR: createAction('ACCOUNTS/ORGANIZATION_USER/ERROR'),
};
export const initialState = Map({
    data: null,
    isProcessing: null,
    error: null,
    loaded: false,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.set('isProcessing', true).set('error', false),
    [actions.SUCCESS]: (state, action) => state
        .set('data', action.payload)
        .set('isProcessing', false)
        .set('error', false)
        .set('loaded', true),
    [actions.ERROR]: (state) => state.set('isProcessing', false).set('error', true).set('loaded', true),
}, initialState);
export const emailSelector = (state) => {
    const data = state.organizationUser.get('data');
    return data && data.boxes && data.boxes[0] && data.boxes[0].identifier;
};
export default reducer;
